import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import LoginHeader from "./../layouts/login-header";
import NavigationBar from "./navigationBar";
import LoanDescription from "./loanDescription";
import EmployerDetails from "./employerDetails";
import PersonalDetails from "./personalDetails";
import SalariedDocument from "./salariedDocument";
import SelfEmployeeDocument from "./selfEmployeeDocument";
import Congratulation from "./congratulation";
import Offers from "./offers";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "./../../config/constant";
import CryptoJS from "crypto-js";
import { useLocation } from "react-router-dom";
import Loading from "../loader/index";
import { MVContext } from "../../Context/mv-context";
export default function Dashboard() {
  const [isAuthenticate, setIsAuthenticate] = useState(
    localStorage.getItem("isAuthenticate")
  );

  let navigate = useNavigate();
  const [loanAmount, setLoanAmount] = useState(50000);
  const [loanPurpose, setLoanPurpose] = useState("");
  const [subLoanPurpose, setSubLoanPurpose] = useState("");
  const [duration, setDuration] = useState("");
  const [loanPurposeError, setLoanPurposeError] = useState(false);
  const [subLoanPurposeError, setSubLoanPurposeError] = useState(false);
  const [durationError, setDurationError] = useState(false);
  const [activeCard, setActiveCard] = useState("loan-card");
  const [activeStatus, setActiveStatus] = useState(0);
  const [userType, setUserType] = useState("salaried");
  const [businessType, setBusinesType] = useState("");
  const [iFileType, setIFileType] = useState("");
  const [isDisableBtn, setIsDisableBtn] = useState(false);
  const [display, setDisplay] = useState("none");
  const [caseId, setCaseId] = useState("");
  const [resData, setResData] = useState("");
  const [profileData, setProfileData] = useState([]);
  const handleRange = (e) => {
    setLoanAmount(parseInt(e[1]));
  };
  const handleDuration = (duration) => {
    setDurationError(false);
    setDuration(duration);
  };
  const handleLoanPurpose = (e) => {
    setLoanPurposeError(false);
    setLoanPurpose(e.target.value);
  };
  const handleSubLoanPurpose = (e) => {
    setSubLoanPurposeError(false);
    setSubLoanPurpose(e.target.value);
  };
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const utm_source = queryParams.get("utm_source");
  const handleLoanAmount = (e) => {
    //console.log(parseInt(e))
    setLoanAmount(e ? e : 0);
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    const param = searchParams.get("_action");
    const secretPass = "my-secret";
    const bytes = CryptoJS.AES.decrypt(param.replace(/ /g, "+"), secretPass);
    const data = bytes.toString(CryptoJS.enc.Utf8);
    setLoanPurpose(data);
  }, [search]);

useEffect(() => {
  const initialize = async () => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });

    if (isAuthenticate !== "true") {
      navigate("/login");
      return;
    }

    const loanPurposeInt = Number(loanPurpose);
    const creditScore = Number(localStorage.getItem("creditScore"));
    const minScore = loanPurposeInt === 2 ? 700 : 650;

    if (creditScore > 0 && creditScore < minScore) {
      await Swal.fire({
        icon: "warning",
        title: "Application Not Eligible",
        text: "Due to our internal policy, you are not eligible to apply at this time. Please try again after 90 days.",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      localStorage.clear();
      navigate("/login", { replace: true });
      return;
    }

    const activeCaseId = localStorage.getItem("active_case_id");
    const isCaseClose = localStorage.getItem("is_case_close");

    if (activeCaseId && isCaseClose === "false") {
      await getProfileData();
    }
  };

  initialize();
}, [isAuthenticate]);

  const getProfileData = async () => {
    try {
      setDisplay("flex");

      const { data: tokenResponse } = await axios.post(
        API_URL + "token/generate-token",
        {
          user_id: localStorage.getItem("user_id"),
        }
      );

      if (!tokenResponse?.token) {
        return false;
      }

      const { data: response } = await axios.post(
        API_URL + "profile/details",
        {
          caseId: localStorage.getItem("active_case_id"),
          token: tokenResponse.token,
        }
      );

      if (response?.status !== 200) {
        return false;
      }

      const profile = response.respData;
      const loan = profile.loan_requirement || {};

      setProfileData(profile);

      setLoanAmount(loan.loan_required_amount || 50000);
      setSubLoanPurpose(loan.sub_loan_of_purpose || "");
      setDuration(loan.loan_duration || "");
      setUserType(profile.user_detail?.user_type || "salaried");
      setBusinesType(profile.personal_detail?.business_type || "");

      localStorage.setItem(
        "panName",
        profile.personal_detail?.name || ""
      );

      return true;
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      setDisplay("none");
    }
  };
  useEffect(() => {
    if (localStorage.getItem("active_case_id")) {
      setCaseId(localStorage.getItem("active_case_id"));
    }
  }, [localStorage.getItem("active_case_id"), display]);
  const handleValidationLoan = () => {
    let isFormValid = true;
    if (!loanPurpose) {
      setLoanPurposeError(true);
      isFormValid = false;
    }
    if (loanPurpose !== "5" && !subLoanPurpose) {
      setSubLoanPurposeError(true);
      isFormValid = false;
    }
    if (!duration) {
      setDurationError(true);
      isFormValid = false;
    }
    return isFormValid;
  };
  const handleLoanDescription = async () => {
    if (!handleValidationLoan()) {
      return;
    }

    try {
      setDisplay("flex");
      setIsDisableBtn(true);

      const tokenResponse = await axios.post(
        API_URL + "token/generate-token",
        {
          user_id: localStorage.getItem("user_id"),
        }
      );

      const token = tokenResponse?.data?.token;

      if (!token) {
        throw new Error("Token generation failed.");
      }

      const jsonFormData = {
        userID: localStorage.getItem("user_id"),
        loanAmount,
        loanPurpose,
        subLoanPurpose,
        durationOfLaon: duration,
        token,
        utm_source: utm_source || "",
        caseId: localStorage.getItem("active_case_id") || "",
      };

      const { data: response } = await axios.post(
        API_URL + "user/loan-requirement",
        jsonFormData
      );

      if (response?.status === 200) {
        setCaseId(response.case_id);
        localStorage.setItem("active_case_id", response.case_id);
        const success = await getProfileData();
        if (success) {
          setActiveStatus(2);
          setActiveCard("personal-detail");
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsDisableBtn(false);
      setDisplay("none");
    }
  };
  const handleNextStep = (activeType, businessType) => {
    setActiveStatus(3);
    setUserType(activeType);
    setActiveCard("employer-detail");
    setBusinesType(businessType);
  };
  const handleNextToUplaod = (activeType, IFileType) => {
    setActiveStatus(4);
    setUserType(activeType);
    setActiveCard("upload-document");
    if (IFileType) {
      setIFileType(IFileType);
    }
  };
  const handleCongratulation = (case_number) => {
    setResData(case_number);
    setActiveStatus(5);
    setActiveCard("congratulation");

    // Update URL with &page=thank-you
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", "thank-you");
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    window.history.replaceState(null, "", newUrl);
  };
  const handleSteps = (cardId) => {
    if (activeStatus <= 5 && cardId === "1") {
      setActiveCard("loan-card");
    }
    if (activeStatus <= 5 && activeStatus >= 2 && cardId === "2") {
      setActiveCard("personal-detail");
    }
    if (activeStatus <= 5 && activeStatus >= 3 && cardId === "3") {
      setActiveCard("employer-detail");
    }
    if (activeStatus <= 5 && activeStatus >= 4 && cardId === "4") {
      setActiveCard("upload-document");
    }
    if (activeStatus <= 5 && activeStatus >= 5 && cardId === "5") {
      setActiveCard("congratulation");
    }
  };

  const [offers, setOffers] = useState(false);
  useEffect(() => {
    getPrefiledData(profileData);
    getOfferData(profileData);
  }, [profileData]);

  function getPrefiledData(preData) {
    if (Object.keys(preData).length) {
      //console.log(Object.keys(preData?.loan_requirement));
      if (Object.keys(preData?.loan_requirement).length) {
        setActiveStatus(2);
      }
      if (Object.keys(preData?.personal_detail).length) {
        setActiveStatus(3);
      }
      if (
        Object.keys(preData?.salaried_detail).length ||
        Object.keys(preData?.self_employee_detail).length
      ) {
        setActiveStatus(4);
      }
      if (preData?.files.length) {
        setActiveStatus(5);
        handleSteps(5);
        setActiveCard("congratulation");
        // Update URL with &page=thank-you
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set("page", "thank-you");
        const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
        window.history.replaceState(null, "", newUrl);
      }
    }
  }

  function getOfferData(preData) {
    if (Object.keys(preData).length) {
      if (preData?.offers.length) {
        setOffers(true);
      }
    }
  }

  const loading = (data) => {
    setDisplay(data);
  };

  const handelMinValue = () => {
    if (loanAmount < 50000) {
      setLoanAmount(50000);
    }
    if (loanPurpose == "2" && loanAmount > 5000000) {
      setLoanAmount(5000000);
    }
    if (loanPurpose != "2" && loanAmount > 10000000) {
      setLoanAmount(10000000);
    }
  };

  const panName = (data) => {
    //console.log("panName",data);
    localStorage.setItem("panName", data);
  };
  return (
    <>
      <LoginHeader />
      <div className="container">
        <div className="row">
          <NavigationBar
            activeStatus={activeStatus}
            handleSteps={handleSteps}
            preFillData={profileData}
            offers={offers}
          />
          <LoanDescription
            handleLoanAmount={handleLoanAmount}
            activeCard={activeCard}
            preFillData={profileData?.loan_requirement}
            loanAmount={loanAmount}
            handleLoanDescription={handleLoanDescription}
            handleRange={handleRange}
            handleLoanPurpose={handleLoanPurpose}
            loanPurpose={loanPurpose}
            duration={duration}
            handleDuration={handleDuration}
            loanPurposeError={loanPurposeError}
            durationError={durationError}
            isDisableBtn={isDisableBtn}
            handleSubLoanPurpose={handleSubLoanPurpose}
            subLoanPurpose={subLoanPurpose}
            subLoanPurposeError={subLoanPurposeError}
            handelMinValue={handelMinValue}
          />
          <PersonalDetails
            caseId={caseId}
            loanPurpose={loanPurpose}
            activeCard={activeCard}
            preFillData={profileData}
            handleNextStep={handleNextStep}
            loading={loading}
            panName={panName}
          />
          <EmployerDetails
            caseId={caseId}
            activeCard={activeCard}
            preFillData={profileData}
            employmentDetail={userType}
            handleNextToUplaod={handleNextToUplaod}
            businessTypeSelect={businessType}
            loading={loading}
            loanAmount={loanAmount}
          />
          <SalariedDocument
            caseId={caseId}
            activeCard={activeCard}
            preFillData={profileData}
            userType={userType}
            handleCongratulation={handleCongratulation}
            loading={loading}
          />
          <SelfEmployeeDocument
            caseId={caseId}
            activeCard={activeCard}
            preFillData={profileData}
            userType={userType}
            businessTypeSelect={businessType}
            iFileType={iFileType}
            handleCongratulation={handleCongratulation}
            loading={loading}
          />
          <Congratulation
            activeCard={activeCard}
            resData={resData}
            preFillData={offers}
            profileData={profileData}
          />
          {/*<Offers activeCard={activeCard} resData={resData} preFillData = {offers} />*/}
          <Loading dispaly={display} />
        </div>
      </div>
    </>
  );
}
